import React from 'react';
import { graphql } from 'gatsby';
import { MDXRenderer } from 'gatsby-plugin-mdx';

import Layout from '../components/layout';
import SEO from '../components/seo';

export const query = graphql`
  query ($slug: String) {
    mdx(fields: { slug: { eq: $slug } }) {
      frontmatter {
        title
        date(formatString: "MMM D, YYYY")
        lastUpdated(formatString: "MMM D, YYYY")
        pinned
      }
      body
    }
  }
`;

const Article = ({ data }) => {
  return (
    <Layout>
      <SEO title={`${data.mdx.frontmatter.title}`} article />
      <h2>{data.mdx.frontmatter.title}</h2>
      <span className="text-gray-400 mb-6 -mt-3 text-lg">
        {data.mdx.frontmatter.pinned
          ? `Last updated: ${data.mdx.frontmatter.lastUpdated}`
          : `${data.mdx.frontmatter.date} · Last updated: ${data.mdx.frontmatter.lastUpdated}`}
      </span>
      <MDXRenderer>{data.mdx.body}</MDXRenderer>
    </Layout>
  );
};

export default Article;
